import { TProduct } from '@/screens/Product/page/types/types'

export const getAddToCart = (
	product: Partial<TProduct>,
	category: string,
	location: string
): Record<string, any> | null => {
	return {
		event: 'add_to_cart',
		ecommerce: {
			currencyCode: 'RUB',
			add: {
				products: [
					{
						id: product.KOD,
						name: product.TITLE,
						price: product.PRICE.VALUE,
						brand: product.PROPERTIES?.osnovnye_parametry?.GROUP_PROPERTIES?.PROIZVODITEL?.values[0],
						category: category || ``,
						quantity: 1,
						list: location || '',
						position: 1
					}
				]
			}
		}
	}
}
